(() => {
  const selector = '[data-idole-product-quantity-total]';

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency || 'USD'
      }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2);
    }
  }

  function updateTotal(input) {
    if (!(input instanceof HTMLInputElement) || input.name !== 'quantity') return;

    const scope = input.closest('safe-sticky, product-info, .product-info') || document;
    const total = scope.querySelector(selector);
    if (!total) return;

    const quantity = Math.max(1, Number.parseInt(input.value, 10) || 1);
    const unitPrice = Number.parseInt(total.dataset.unitPrice || '0', 10);
    const currency = total.dataset.currency || 'USD';
    const unitFormatted = formatMoney(unitPrice, currency);

    const label = total.querySelector('[data-idole-product-total-label]');
    const price = total.querySelector('[data-idole-product-total-price]');
    const formula = total.querySelector('[data-idole-product-total-formula]');

    if (label) label.textContent = document.documentElement.lang === 'ar' ? `المجموع لـ ${quantity}` : `Total for ${quantity}`;
    if (price) price.textContent = formatMoney(unitPrice * quantity, currency);
    if (formula) formula.textContent = `${unitFormatted} × ${quantity}`;
  }

  function initialize(root = document) {
    root.querySelectorAll('input[name="quantity"]').forEach(updateTotal);
  }

  document.addEventListener('input', event => updateTotal(event.target));
  document.addEventListener('change', event => updateTotal(event.target));
  document.addEventListener('shopify:section:load', event => initialize(event.target));

  document.addEventListener('click', event => {
    const control = event.target.closest('quantity-selector button');
    if (!control || !control.closest('safe-sticky, product-info, .product-info')) return;
    requestAnimationFrame(() => {
      const input = control.closest('quantity-selector')?.querySelector('input[name="quantity"]');
      if (input) updateTotal(input);
    });
  });

  initialize();
})();